import './bannerCard.scss';

import React from 'react';
import { PropTypes } from 'prop-types';

import PercentagePill from '../percentagePill/percentagePill';

import { i18n } from 'core/i18n';
const { formatText } = i18n;

export function getFormattedValue(value, decimals = 4) {
  const adjust = Math.pow(10, decimals);
  const decimalsNumber = Math.floor(value * adjust) / adjust;
  const parsed = String(decimalsNumber).replaceAll('.', ',');

  return parsed;
}

const BannerCard = ({ realTimeValue, percentPrediction, currency, estimateKey, currentPrice }) => {
    const hasData = !isNaN(parseInt(percentPrediction));

    const predictedValue = realTimeValue + realTimeValue * (percentPrediction / 100);
    const formattedValue = getFormattedValue(predictedValue);
    const valueCurrency = hasData ? `${formattedValue} ${currency}` : '';
    const realPercentage = hasData
        ? 100 * ((predictedValue - currentPrice) / Math.abs(currentPrice))
        : percentPrediction;

    return (
        <div className="brokerIA-bannerCard">
            <h4 className="brokerIA-bannerCard__title">{formatText(estimateKey)}</h4>
            <div className="brokerIA-bannerCard__content">
                <span className="brokerIA-bannerCard__value">{valueCurrency}</span>
                <PercentagePill percent={realPercentage} compact={true} product={true} />
            </div>
        </div>
    );
};

BannerCard.propTypes = {
    realTimeValue: PropTypes.number.isRequired,
    percentPrediction: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    estimateKey: PropTypes.string.isRequired,
    currentPrice: PropTypes.number.isRequired
};

export default BannerCard;
